<section class="form">
  <form [formGroup]="formTable" (ngSubmit)="addData()">
    <!-- <div class="style-input-default input_table" data-text="Fecha *" [ngClass]="{error: verificateInput('fecha')}">
        <input type="text" placeholder="Fecha" formControlName="fecha">
      </div> -->
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Fecha</mat-label>
      <input matInput formControlName="fecha" [matDatepicker]="picker3" />
      <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
      <mat-datepicker #picker3></mat-datepicker>
    </mat-form-field>
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>Observación</mat-label>
      <textarea
        matInput
        placeholder="Observación"
        formControlName="observacion"
      ></textarea>
    </mat-form-field>
    <!-- <div  data-text="Observación *" [ngClass]="{error: verificateInput('observacion')}">
        <input type="text" placeholder="Observación" formControlName="observacion">
      </div> -->
    <div style="text-align: end">
      <button
        class="button"
        *ngIf="!status"
        type="submit"
        [disabled]="formTable.invalid || submit"
      >
        Agregar Observación
      </button>
    </div>

    <!-- <button class="buttonAdd" type="submit" [disabled]="formTable.invalid || submit">
        <i class="fas fa-plus"></i>
      </button> -->
  </form>
</section>

<div class="task_content_table">
  <table mat-table #dataTable [dataSource]="dataSource" class="task_table">
    <ng-container matColumnDef="fecha">
      <th class="header-options" mat-header-cell *matHeaderCellDef>Fecha</th>
      <td mat-cell *matCellDef="let element">
        {{ element.fecha | date : "d/M/yy" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="observacion">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Observación
      </th>
      <td mat-cell *matCellDef="let element">{{ element.observacion }}</td>
    </ng-container>

    <!-- <ng-container matColumnDef="opciones">
        <th class="header-options" mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element; let i = index">
          <div class="options">
            <button class="delete" (click)="removerCuenta(i)"><i class="fas fa-times"></i></button>
          </div>
        </td>
      </ng-container> -->

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<mat-paginator
  [pageSizeOptions]="[5, 10, 25, 50, 100]"
  [pageSize]="5"
  [showFirstLastButtons]
></mat-paginator>
